export default __webpack_public_path__ + "static/media/Step2.c6a40713.png";